/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import "./InviteFriends.css";
import SignupModal from "../Shared/SignupModal";
import GiftLottie from "../Shared/GiftLottie";
import MainBackgroundWrapper from "../Shared/MainBackgroundWrapperForMarketplace";
import NavbarRedesignForMarketplace from "../Shared/NavbarRedesignForMarketplace";
import HelmetTag from "../Shared/HelmetTag";
import CTAButton from "../Shared/CTAButton";

class InviteFriends extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCopiedMessage: false,
      width: window.innerWidth,
    };
    this.handleCopyCode = this.handleCopyCode.bind(this);
    this.handleInviteFriends = this.handleInviteFriends.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setState({ width: window.innerWidth });
    });
  }

  handleCopyCode() {
    const invite_url = get(this.props, "client.invite_url", "");
    navigator?.clipboard?.writeText(invite_url).then(() => {
      this.setState({ showCopiedMessage: true });
      setTimeout(() => {
        this.setState({ showCopiedMessage: false });
      }, 2000);
    });
  }

  handleInviteFriends() {
    const invite_url = get(this.props, "client.invite_url", "");
    const invite_code = get(this.props, "client.invite_code", "");
    const give_referral_string = get(
      this.props,
      "client.give_referral_string",
      ""
    );

    const shareData = {
      title: `Get ${give_referral_string} off your first Soothe booking!`,
      text: `Use my referral code ${invite_code} and get ${give_referral_string} off your first appointment with Soothe - in-home wellness services.`,
      url: invite_url,
    };

    // Check if Web Share API is supported (mainly mobile devices)
    if (
      navigator.share &&
      navigator.canShare &&
      navigator.canShare(shareData)
    ) {
      navigator
        .share(shareData)
        .then(() => {
          // Share was successful
        })
        .catch((error) => {
          // Fall back to copying URL if share fails
          this.handleCopyCode();
        });
    } else {
      // Fall back to copying URL for desktop or unsupported browsers
      this.handleCopyCode();
    }
  }

  render() {
    const { showCopiedMessage, width } = this.state;
    const loggedIn = get(this.props, "client.loggedIn", false);
    const invite_code = get(this.props, "client.invite_code", "");
    const total_clients_invited = get(
      this.props,
      "client.referrals.total_clients_invited",
      0
    );
    const total_credits_earned = get(
      this.props,
      "client.referrals.total_credits_earned",
      0
    );
    const give_referral_string = get(
      this.props,
      "client.give_referral_string",
      ""
    );
    const get_referral_string = get(
      this.props,
      "client.get_referral_string",
      ""
    );

    // Uncomment if you want to force login modal
    if (!loggedIn) {
      return (
        <SignupModal
          isSignin
          next={() => {
            window.location.reload();
          }}
        />
      );
    }

    return (
      <>
        <HelmetTag title="Invite Friends" />
        <NavbarRedesignForMarketplace notBooking showMenu />
        <MainBackgroundWrapper noMarginTop={width < 800} bgImagePath="#fff">
          <div
            style={{
              marginLeft: width >= 1000 ? "15vw" : 0,
              padding: width >= 1000 ? '0' : '80px 16px',
              transition: "margin-left 0.2s",
              minHeight: "calc(100vh - 80px)",
            }}
            className="mb-100"
          >
            <div
              className={`${
                width >= 800 ? "max-width-65 p-24" : "mb-48"
              } invite-friends-figma-root`}
            >
              {/* Hero Section */}
              <div className="invite-hero">
                <GiftLottie />
              </div>
              {/* Headline and Subtext */}
              <div className="invite-headline-section">
                <div className="size-40-52 font-weight-bold contentPrimary mb-16">
                  Refer a friend, get {get_referral_string}
                </div>
                <div className="size-18-28 contentSecondary mb-24">
                  Know someone who would love Soothe? They'll get{" "}
                  {give_referral_string} off by using your code at checkout and
                  when they complete their first appointment, you'll get{" "}
                  {get_referral_string}!{" "}
                  <a
                    className="CactusFlowerPrimary deco-none"
                    href="/legal/terms/b2c/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms apply.
                  </a>
                </div>
              </div>
              {/* Referral Code Card */}
              <div className="invite-referral-card">
                <div className="invite-referral-card-content">
                  <div className="invite-referral-labels">
                    <div className="size-22-30 font-weight-bold contentPrimary mb-4">
                      {invite_code}
                    </div>
                    <div className="size-14-20 contentSecondary">
                      Your referral code
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn invite-copy-btn"
                    onClick={this.handleCopyCode}
                  >
                    Copy
                  </button>
                </div>
              </div>
              {width > 1000 ? null : width <= 1000 && width > 800 ? (
                <button
                  type="button"
                  className="btn md-cta-primary mb-32"
                  onClick={this.handleInviteFriends}
                  style={{ width: "auto" }}
                >
                  Invite Friends
                </button>
              ) : (
                <CTAButton
                  text="Invite Friends"
                  action={this.handleInviteFriends}
                  additionalClass="md-cta-primary centered p-16-20-imp"
                />
              )}
              {/* Stats Section */}
              <div className="invite-stats">
                <div className="size-24-32 font-weight-bold contentPrimary mb-24">
                  Referral activity
                </div>
                <div className="invite-stats-cards">
                  <div className="invite-stat-card">
                    <div className="size-20-28 font-weight-bold contentPrimary mb-4">
                      {total_clients_invited}
                    </div>
                    <div className="size-14-20 contentSecondary">
                      Referrals completed
                    </div>
                  </div>
                  <div className="invite-stat-card">
                    <div className="size-20-28 font-weight-bold systemGreen mb-4">
                      {total_credits_earned}
                    </div>
                    <div className="size-14-20 contentSecondary">
                      Total earned
                    </div>
                  </div>
                </div>
              </div>
              {/* Snackbar always mounted for animation */}
              <div
                className="invite-snackbar"
                style={{ display: showCopiedMessage ? "block" : "none" }}
                aria-live="polite"
              >
                Invite link copied to clipboard!
              </div>
            </div>
          </div>
        </MainBackgroundWrapper>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.client,
});

export default connect(mapStateToProps)(InviteFriends);
